import PaginationMetaDetails from "./PaginationMetaDetails";
import PreviousButton from "./PreviousButton";
import NextButton from "./NextButton";
import PageNumber from "./PageNumber";

function Pagination({ pagination, loading, handlePageChange }) {
    if (!pagination || pagination.total <= 0) {
        return null;
    }

    return (
        <div className="pagination">
            <PaginationMetaDetails pagination={pagination} />

            <div className="pagination-buttons-group">
                <PreviousButton pagination={pagination} loading={loading} handlePageChange={handlePageChange} />
                <PageNumber pagination={pagination} loading={loading} handlePageChange={handlePageChange} />
                <NextButton pagination={pagination} loading={loading} handlePageChange={handlePageChange} />
            </div>
        </div>
    );
}

export default Pagination;